import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Actions } from "../../../core/modules/Actions";
import { Box, Checkbox, Divider, Grid } from "@mui/material";
import {
  DatePickerComponent,
  TextInputComponent,
} from "../../../component/atom";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import TextButtonComponet from "../../../component/atom/Buttons/TextButton";
import DropDownComponent from "../../../component/atom/Inputs/DropDown";
import {
  CurrencySelector,
  ViewSelectedCurrency,
} from "../../../component/molecule";
import { getText, promoCodeTypes } from "../../../core/Constant";
import ShortUniqueId from "short-unique-id";
import _ from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import ViewSelectedCoursePlan from "../../../component/molecule/ViewSelectedCoursePlan/ViewSelectedCoursePlan";
import ViewSelectedCurrencies from "../../../component/molecule/ViewSelectedCurrencies/ViewSelectedCurrencies";

const AddPromoCode = ({ courseList, getCourseList, getCourseMainDetails, mainDetailsState }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [promoCode, setPromoCode] = useState("");
  const [promoCodeValid, setPromoCodeValid] = useState(false);
  const [promoCodeError, setPromoCodeError] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [startDateError, setStartDateError] = useState(false);
  const [startDateValid, setStartDateValid] = useState(true);
  const [endDate, setEndDate] = useState(new Date());
  const [endDateValid, setEndDateValid] = useState(true);
  const [endDateError, setEndDateError] = useState(false);
  const [precentage, setPrecentage] = useState("");
  const [precentageValid, setPrecentageValid] = useState(false);
  const [precentageError, setPrecentageError] = useState(false);
  const [checked, setChecked] = useState(true);
  const [promoCodeType, setPromoCodeType] = useState(1);
  const [listAmount, setListAmount] = useState([]);
  const [listAmountError, setListAmountError] = useState(false);
  const [listPlans, setListPlans] = useState([]);
  const [planListError, setPlanListError ] = useState({
    course:"",
    plan:""
  })
  const [listPlanError, setListPlanError] = useState(false);
  const [courseId, setCourseId] = useState(0);
  const [planId, setPlanId] = useState()
  const [plans, setPlans] = useState([])


  const promoCodeTypeList = [
    { promoTypeId: 1, promoType: "Precentage" },
    { promoTypeId: 2, promoType: "As an amount" },
  ];
  const uid = new ShortUniqueId({ length: 8 });

  useEffect(() => {
    getCourseList();
  }, []);

  useEffect(()=>{
    if(courseId){
       getCourseMainDetails({
         id: courseId,
      });
    }
  },[courseId])

  useEffect(()=>{
    if(mainDetailsState?.is_free === 0 && mainDetailsState?.course_currencies?.length > 0){
      const formattedPlan = mainDetailsState?.course_currencies?.map((plan)=>{
        let batch = ""
        if(plan?.batch_month && plan?.batch_year){
         batch = `${moment()
                   .month(Number(plan?.batch_month) - 1)
                   .format("MMMM")} ${plan?.batch_year}`
        }
        return {
          id: plan?.id, 
          name: plan?.plan_name || batch
        }
      })
      setPlans(formattedPlan)
    } else{
      setPlans([])
    }
  },[mainDetailsState])

  const handleChangeDropdown = async (event) => {
    const value = getText(event);
    setPromoCodeType(value);
    console.log(value);
  };

  const handleOnChangeGenarate = (e) => {
    const value = getText(e);
    if(value.trim().length  > 5 &&  value.trim().length < 8){
      setPromoCodeError(false);
      setPromoCodeValid(true);
      setPromoCode(value);
    }else{
      setPromoCodeError(true);
      setPromoCodeValid(false);
      setPromoCode(value);
    }
   
  };
  const handleOnChangeStartDate = (date) => {
    setStartDate(date);
    setStartDateValid(true);
    setStartDateError(false);
    handleOnChangeEndDate(new Date(new Date().setDate(new Date(date).getDate() + 1)));
  };
  const handleOnChangeEndDate = (date) => {
    setEndDate(date);
    setEndDateValid(true);
    setEndDateError(false);
  };
  const handleOnChangePercentage = (e) => {
    const value = getText(e);
    setPrecentageError(false);
    setPrecentageValid(true);
    setPrecentage(value);
  };

  const handleOnChangeOneTime = (e) => {
    setChecked(e?.target?.checked);
  };

  const onClickGenarate = () => {
    setPromoCode(uid.rnd());
    setPromoCodeError(false);
    setPromoCodeValid(true);
    // setPromoCode(value);
  };

  const handleSubmit = async (event) => {
    if (
      promoCodeValid &&
      startDateValid &&
      endDateValid &&
      ((promoCodeType == 1 && precentageValid) || listAmount.length > 0)
    ) {
      let list = _.map(listAmount, (item, i) => {
        return { ...{ amount: item?.amount, currency_id: item?.id } };
      });

      let precentageValue = [{ amount: precentage, currency_id: 0 }];

      let startDateObj = moment(startDate);
      let sdate = startDateObj.format("YYYY-MM-DD");

      let endDateObj = moment(endDate);
      let edate = endDateObj.format("YYYY-MM-DD");

      const selectedPlans = listPlans?.map((plan)=> {
        return {
          course_id: plan?.courseId,
          course_plan_type_id: plan?.planId
        }
      })
      const paramsWithPerc = {
         promo_code: promoCode,
         start_date: sdate,
         expiration_date: edate,
         discount_type: promoCodeType,
         is_one_time: checked ? 1 : 0,
         percentage: precentage || 0,
         course_plans : selectedPlans || []
      }

      const paramsWithAmount = {
         promo_code: promoCode,
         start_date : sdate,
         expiration_date: edate,
         discount_type: promoCodeType,
         is_one_time: checked ? 1 : 0,
         course_plans : selectedPlans || [],
         price: list
      }
      dispatch(
        Actions.promoCode.createPromoCode(promoCodeType === 1 ? paramsWithPerc : paramsWithAmount)
      );
      navigate(-1);
    } else {
      if (!promoCodeValid) {
        setPromoCodeError(true);
      }
      if (!startDateValid){
        setStartDateError(true);
      }
      if (!endDateValid){
        setEndDateError(true);
      }
      if (promoCodeType == 1 && !precentageValid){
        setPrecentageError(true);
      }

      if (promoCodeType == 2 && listAmount.length == 0){
       setListAmountError(true);
      }

    }
  };

  const onAddCurrency = ({ amount, currencyData, currency }) => {
    const index = _.findIndex(listAmount, (i) => i?.id == currency);
    let list = listAmount;
    if (index > -1) {
      list = _.map(listAmount, (item, i) => {
        if (i == index) {
          const isRemoved = item?.isRemoved;
          return { amount, ...currencyData, isRemoved };
        }
        return item;
      });
    } else {
      list = [...listAmount, { amount, ...currencyData , isRemoved: true}];
    }
    setListAmount(list);
    setListAmountError(false);
  };


  const onAddPlans = ({ courseId, planId }) => {
    setListPlanError(false)   
    const course = courseList?.find((course)=> course?.id === courseId)
    const course_name = course?.name
    const plan = plans?.find((plan)=> plan?.id === planId)
    const plan_name = plan?.name
    if(!courseId){
       setPlanListError((prevState)=>{
         return { ...prevState,course:"Please select a course."  }
       });
    }
    if(plans?.length > 0 && !planId){
     setPlanListError((prevState)=>{
         return { ...prevState,plan:"Please select a plan."  }
       });
    }

    if(!courseId || (plans?.length > 0 && !planId)) return
    
    const isPlanAlreadyAdded = listPlans.some(
       (item) => item.courseId === courseId && item.planId === planId
    );

    if(isPlanAlreadyAdded && plans?.length === 0){
       setPlanListError({
        course: "The selected course is already added.",
        plan: "",
      });
      return;
    }

    if (isPlanAlreadyAdded) {
      setPlanListError({
        course: "",
        plan: "The selected plan is already added.",
      });
      return;
    }
    
    setListPlans((prevState)=> {
      return [ ...prevState, { courseId, planId, plan_name, course_name, isRemoved:true  } ]
    });
    setPlanListError({
      course:"",
      plan:""
    });
  };

  const onRemovePlan = (item)=>{
    setListPlans((prevState)=>{
      return [ ...prevState?.filter((plan)=> !(plan.courseId === item?.courseId && plan.planId === item?.planId) ) ]
    })
  }

  const onClickRemoveAmountItem = (item) => {
    const list = _.filter(listAmount, (value) => {
      return item?.id != value?.id;
    });
    setListAmount(list);
  };

  // const clearData = () => {
  //   setChecked(true);
  //   setEndDate("");
  //   setStartDate("");
  //   setListAmount([]);
  //   setPromoCode("");
  //   setPromoCodeType(1);
  // };

  return (
    <Box className="main-screen-container">
      <Grid container>
        <Grid item>
          <HeadingComponent
            text={"Add Promo Code"}
            fontweigth={600}
            size={40}
            fontfamily={"Montserrat"}
            backNavigation={true}
          />
        </Grid>
      </Grid>
      <Box>
        <Grid container>
          <Grid item xs={12}>
            <Grid container alignItems={"center"}>
              <Grid item xs={10} sm={9}>
                <TextInputComponent
                  label={"Generate The Promo Code"}
                  placeholder="Promo Code"
                  value={promoCode}
                  isError={promoCodeError}
                  error="Please enter or generate a promo code"
                  onchange={handleOnChangeGenarate}
                />
              </Grid>
              <Grid item xs={2} sm={3} mt={4}>
                <TextButtonComponet
                  text={"Generate"}
                  width={"100%"}
                  // isDisabled={postBtnStatus}
                  onButtonClick={() => onClickGenarate()}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item md={6} xs={12}>
            <DatePickerComponent
            isError={startDateError}
            error={"Select a valid date"}
              label="Start Date"
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={(date) => handleOnChangeStartDate(date)}
              selectsStart
              minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
              startDate={startDate}
              endDate={endDate}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <DatePickerComponent
              label="Expiry Date"
              error={"Select a valid date"}
              isError={endDateError}
              dateFormat="dd/MM/yyyy"
              selected={endDate}
              onChange={(date) => handleOnChangeEndDate(date)}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
            />
          </Grid>

          <Grid item xs={6}>
            <DropDownComponent
              dropdownLabel="Promo Code Type"
              selectedValue={promoCodeType}
              onchange={handleChangeDropdown}
              list={promoCodeTypeList}
              isShowZero={false}
              fixedWidth="100%"
            />
          </Grid>
          {promoCodeType == 1 ? (
            <Grid item xs={6}>
              <TextInputComponent
                label={"Percentage"}
                placeholder="Percentage"
                value={precentage}
                isError={precentageError}
                error="Please enter a percentage"
                onchange={handleOnChangePercentage}
              />
            </Grid>
          ) : null}
        </Grid>

        {promoCodeType !== 1 ? (
          <Grid container flexDirection={"column"} mt={1} gap={1} sx={{
             paddingRight:1,
          paddingLeft:3,
          marginTop:3 
          }}>
            <Grid item>
              <CurrencySelector onClickAdd={onAddCurrency} />
            </Grid>
            {listAmountError ? <p className="input-error-text">Currencies are not selected</p> : null}
          </Grid>
        ) : null}

        {promoCodeType === promoCodeTypes.AMOUNT && listAmount?.length > 0 ? (
         <Grid container sx={{
           paddingLeft:1,
           paddingRight:1,
           mt:2
         }}>
         <Grid item xs={12}>
           <ViewSelectedCurrencies
             onClickRemove={onClickRemoveAmountItem}
             list={listAmount}
           />
         </Grid>
         </Grid>
       ) : null} 


        <Grid container sx={{
           paddingRight:1,
           paddingLeft:3,
         }} 
        flexDirection={"column"} 
        mt={promoCodeType !== 1 ? 5 : 3} 
        gap={1}>
            <Grid item>
               <Grid
                container
                spacing={2}
                p={2}
                alignItems="center"
                sx={{
                  backgroundColor: "#FAF5FE",
                  borderTopLeftRadius: 2,
                  borderTopRightRadius: 2,
                  paddingBottom:4
                }}
              >
                <Grid item xs={12} sm={5} md={4}>
                  <DropDownComponent
                    isShowZero={false}
                    dropdownLabel="Course"
                    backgroundColor={"#fff"}
                    onchange={(e) =>{  
                      setCourseId(e.target.value) 
                      setPlanId("") 
                      setPlanListError((prevState)=>{
                        return { ...prevState ,course:"", plan:""  }
                      })
                    }}
                    selectedValue={courseId}
                    list={courseList}
                    fixedWidth="100%"
                    outerStyle={{
                      paddingBottom:0
                    }}
                  />
                  {planListError?.course ? <p style={{ marginBottom:0 }} className="input-error-text">{planListError?.course}</p> : null}
                </Grid>
                <Grid item xs={12} sm={4} md={4} >
                  {
                    plans?.length > 0 && (<><DropDownComponent
                    outerStyle={{
                      paddingBottom:0
                    }}
                    isShowZero={false}
                    dropdownLabel="Plan"
                    backgroundColor={"#fff"}
                    onchange={(e) => { 
                      setPlanId(e.target.value) 
                      setPlanListError((prevState)=>{
                        return { ...prevState , plan:""   }
                      })
                    }}
                    selectedValue={planId}
                    list={plans}
                    fixedWidth="100%"
                  />
                   {planListError?.plan ? <p style={{ marginBottom:0 }} className="input-error-text">{planListError?.plan}</p> : null}
                  </>
                  )
                  }
                 
                </Grid>
                <Grid item xs={12} sm={3} md={2}>
                  <Box
                    sx={{
                      width: "100%",
                      mt: { xs: 0, sm: 3.5 },
                    }}
                  >
                    <TextButtonComponet
                      text={"Add"}
                      onButtonClick={()=>{ onAddPlans({ courseId, planId }) }}
                    />
                  </Box>
                </Grid>
              </Grid>            
            </Grid>
        {listPlanError ? <p className="input-error-text">Plans are not selected</p> : null}
        </Grid>

            {listPlans?.length > 0 ? (
              <Grid container sx={{
                paddingLeft:1,
                paddingRight:1,
                mt:2
              }}>
              <Grid item xs={12}>
                <ViewSelectedCoursePlan
                  onClickRemove={onRemovePlan}
                  list={listPlans}
                />
              </Grid>
              </Grid>
            ) : null} 

        <Grid container alignItems={"center"} p={2} >
          <Grid item>
            <p style={{ padding: 0, margin: 0 }}>Is one time use promo code</p>
          </Grid>
          <Grid item>
            <Checkbox
              checked={checked}
              onChange={handleOnChangeOneTime}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            />
          </Grid>
        </Grid>

        <Grid container mt={4} justifyContent={"center"} alignItems={"center"}>
          <Grid item xs={3}>
            <TextButtonComponet
              text={"Add"}
              width={120}
              // isDisabled={postBtnStatus}
              onButtonClick={() => handleSubmit()}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default connect(
  (state) => ({
    courseList: state.students.get("commonCourseList"),
    mainDetailsState: state.course.get("mainDetailsState"),
  }),
  {
    getCourseList: Actions.students.getCourseList,
    getCourseMainDetails: Actions.course.getCourseMainDetails,
  }
)(AddPromoCode);

